import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.AddFieldHeaderColumn', {
    addFieldTitle: 'Add new or existing fields to be used in rules',
    addFieldPlaceholder: 'Name a field',
    addField: 'Add a field',
});
